import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-flag-cs",
  "use": "icon-flag-cs-usage",
  "viewBox": "0 0 640 480",
  "content": "<symbol viewBox=\"0 0 640 480\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-flag-cs\">\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.160034 240H640V480H0.160034V240Z\" fill=\"#E80000\" />\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0H639.84V240H0V0Z\" fill=\"white\" />\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0L318.837 239.719L0 479.062V0Z\" fill=\"#00006F\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol